import React, { useState } from "react";
import ModalTrigger from "./ModalTrigger";
import InclusionsExclusions from "./InclusionsExclusions";
import CancellationPolicy from "./CancellationPolicy";
import TrekThingsToCarry from "../SahydriTreks/TrekThingsToCarry";
import TrekAdvisory from "../Policies/TrekAdvisory";
import CampAdvisory from "../Policies/CampAdvisory";
import BookingInstructions from "./BookingInstructions";
import FAQSection from "./FAQSection";

const ModalTriggerList = ({ inclusions, exclusions, type, faq }) => {
  const [activeModal, setActiveModal] = useState(null);

  const handleOpen = (modalName) => setActiveModal(modalName);
  const handleClose = () => setActiveModal(null);

  const getAdvisoryComponent = () => {
    return type === "trek"
      ? TrekAdvisory
      : type === "camp"
        ? CampAdvisory
        : null;
  };

  const modalItems = [
    {
      label: "Inclusions & Exclusions",
      modalKey: "inclusions",
      Component: InclusionsExclusions,
      props: { inclusions, exclusions },
    },
    {
      label: "Things to Carry",
      modalKey: "thingsToCarry",
      Component: TrekThingsToCarry,
      props: {},
    },
    {
      label: "How to Book?",
      modalKey: "howToBook",
      Component: BookingInstructions,
      props: {},
    },
    {
      label: "Cancellation Policy",
      modalKey: "cancellation",
      Component: CancellationPolicy,
      props: {},
    },
    {
      label: "Advisory",
      modalKey: "Advisory",
      Component: getAdvisoryComponent(),
      props: {},
    },
    {
      label: "FAQ",
      modalKey: "faq",
      Component: FAQSection,
      props: { faq },
    },
  ];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 w-full max-w-3xl mx-auto px-3 sm:px-4">
      {modalItems.map(({ label, modalKey, Component, props }) => (
        <div
          key={modalKey}
          className="bg-white border border-gray-300 rounded-md shadow-sm hover:shadow-md transition"
        >
          <ModalTrigger
            label={
              <div className="flex items-center justify-between px-4 pb-4 whitespace-nowrap">
                <span className="text-gray-800 font-medium text-base leading-none select-none ">
                  {label}
                </span>
                <div className="w-6 h-6 min-w-[1.5rem] flex items-center justify-center text-blue-600 rounded-sm text-base font-bold">
                  →
                </div>
              </div>
            }
            Component={Component}
            componentProps={props}
            isOpen={activeModal === modalKey}
            onOpen={() => handleOpen(modalKey)}
            onClose={handleClose}
            isAnyModalOpen={!!activeModal}
          />
        </div>
      ))}
    </div>
  );
};

export default ModalTriggerList;
